// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-editor-container[data-v-66cee59d]{padding:32px;background-color:#f0f2f5;position:relative}.dashboard-editor-container .github-corner[data-v-66cee59d]{position:absolute;top:0;border:0;right:0}.dashboard-editor-container .chart-wrapper[data-v-66cee59d]{background:#fff;padding:16px 16px 0;margin-bottom:32px}@media(max-width:1024px){.chart-wrapper[data-v-66cee59d]{padding:8px}}", ""]);
// Exports
module.exports = exports;
